import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import PictureUpload from "components/CustomUpload/ImageUpload.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "react-datetime";
import NotifList from "granular/Notification/notifList.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Select from "@material-ui/core/Select";
import { pushLoader } from "../../actions/main";
import { connect } from "react-redux";
import {
  fetchUploadAll,
  deleteOffice,
  pushUpload,
  proccessUpload
} from "../../api/office";

import { fetchPOIOffice, pushOffice, updateOffice } from "../../api/office";
import Officedt from "../../granular/MasterData/officedt";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import _ from "lodash";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";

class Office extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataoffice: this.props.dataoffice,
      openAdd: false,
      openEdit: false,
      urlfile: "-",
      description: "",
      file_upload: "",
      company_code: localStorage.getItem("company_code"),
      user_id: localStorage.getItem("id"),
      loader: null
    };
  }

  UNSAFE_componentWillMount() {
    // console.log(localStorage);
  }

  componentDidMount() {
    // this.getDatatable();
  }

  handleDelete = id => {
    swal({
      icon: "warning",
      title: "Delete",
      text: `Are you sure to delete data office with id: ${id}`,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        deleteOffice(id)
          .then(response => {
            if (response != null) {
              this.getDatatable();
            }
          })
          .catch(error => {
            // console.log("tidak berhasil");
            this.props.history.push("/pages/login#logout");
          });
      }
    });
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  getDatatable = () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchPOIOffice()
      .then(response => {
        if (response != null) {
          this.setState({ dataoffice: response.data.results });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        this.setState({ loader: false });
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
  };

  handleSubmit = () => {
    if (
      this.state.name &&
      this.state.address &&
      this.state.description &&
      this.state.district &&
      this.state.subdistrict &&
      this.state.dimensi &&
      this.state.subdimensi &&
      this.state.latitude &&
      this.state.longitude
    ) {
      pushOffice(this.state)
        .then(response => {
          if (response != null) {
            this.setState({
              description: "-",
              openAdd: false
            });
            this.getDatatable();
          }
        })
        .catch(error => {
          this.props.history.push("/pages/login#logout");
        });
    } else {
      this.setState({ errorCheck: true });
    }
  };

  handleUpdate = id => {
    let datanya = _.find(this.props.dataoffice, { id: id });

    // console.log(datanya);

    this.setState({
      openAdd: true,
      id: datanya.id,
      name: datanya.name,
      address: datanya.address,
      description: datanya.description,
      district: datanya.district,
      subdistrict: datanya.subdistrict,
      dimensi: datanya.dimensi,
      subdimensi: datanya.subdimensi,
      latitude: datanya.latitude,
      longitude: datanya.longitude,
      status: "update",
      title: "Update Office"
    });
  };

  handleFileUpload = event => {
    this.setState({ file_upload: event.target.files[0] });
    //console.log(event.target.files[0].name);

    const ext = event.target.files[0].name.split(".");

    proccessUpload(event.target.files[0], ext[1])
      .then(response => {
        this.setState({ urlfile: response.data.url });
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleAdd = () => {
    this.setState({
      openAdd: true,
      name: "",
      address: "",
      description: "",
      district: "",
      subdistrict: "",
      dimensi: "",
      subdimensi: "",
      latitude: "",
      longitude: "",
      status: "add",
      errorCheck: false,
      title: "Add Office"
    });
  };

  handleChangeText = (keys, e) => {
    this.setState({ [keys]: e.target.value });
  };

  renderAction = () => {
    if (this.state.status == "add") {
      return (
        <Button onClick={() => this.handleSubmit()} color="success" round>
          Add
        </Button>
      );
    } else {
      return (
        <Button onClick={() => this.handleSubmitUpdate()} color="success" round>
          Update
        </Button>
      );
    }
  };

  handleSubmitUpdate = () => {
    if (
      this.state.name &&
      this.state.address &&
      this.state.description &&
      this.state.district &&
      this.state.subdistrict &&
      this.state.dimensi &&
      this.state.subdimensi &&
      this.state.latitude &&
      this.state.longitude
    ) {
      updateOffice(this.state)
        .then(response => {
          if (response != null) {
            this.setState({
              description: "-",
              openAdd: false
            });
            this.getDatatable();
          }
        })
        .catch(error => {
          this.props.history.push("/pages/login#logout");
        });
    } else {
      this.setState({ errorCheck: true });
    }
  };

  handleError = e => {
    if (!e) return true;
    return false;
  };
  handleHelperText = (e, check) => {
    if (this.state.errorCheck) if (check(e)) return "This field is required";
  };

  renderAdd = e => {
    if (localStorage.getItem("userlevel") != 3) {
      return (
        <Button color="success" round onClick={() => this.handleAdd()}>
          Add Data
        </Button>
      );
    } else {
      return <div />;
    }
  };

  render() {
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              {this.renderAdd()}
            </CardHeader>
            <Officedt
              datatable={this.props.dataoffice}
              handleDelete={this.handleDelete}
              handleUpdate={this.handleUpdate}
              loader={this.state.loader}
            />
          </Card>
          <Dialog
            fullScreen
            open={this.state.openAdd}
            onClose={() => this.handleClose("openAdd", false)}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Add Office</DialogTitle>
            <DialogContent>
              <GridContainer>
                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="Name"
                    id="name"
                    helpText={this.handleHelperText(
                      this.state.name,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.name)
                        : false,
                      value: this.state.name,
                      //onChange: e => { this.setState({description: e.target.value}) }
                      onChange: e => this.handleChangeText("name", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="Address"
                    id="address"
                    helpText={this.handleHelperText(
                      this.state.address,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.address)
                        : false,
                      value: this.state.address,
                      //onChange: e => { this.setState({description: e.target.value}) }
                      onChange: e => this.handleChangeText("address", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>

                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="description"
                    id="description"
                    helpText={this.handleHelperText(
                      this.state.description,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.description)
                        : false,
                      value: this.state.description,
                      onChange: e => this.handleChangeText("description", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="District"
                    id="district"
                    helpText={this.handleHelperText(
                      this.state.district,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.district)
                        : false,
                      value: this.state.district,
                      onChange: e => this.handleChangeText("district", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="Sub District"
                    id="subdistrict"
                    helpText={this.handleHelperText(
                      this.state.subdistrict,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.subdistrict)
                        : false,
                      value: this.state.subdistrict,
                      onChange: e => this.handleChangeText("subdistrict", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="Dimensi"
                    id="dimensi"
                    helpText={this.handleHelperText(
                      this.state.dimensi,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.dimensi)
                        : false,
                      value: this.state.dimensi,
                      onChange: e => this.handleChangeText("dimensi", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="Sub Dimensi"
                    id="subdimensi"
                    helpText={this.handleHelperText(
                      this.state.subdimensi,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.subdimensi)
                        : false,
                      value: this.state.subdimensi,
                      onChange: e => this.handleChangeText("subdimensi", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="Latitude"
                    id="latitude"
                    helpText={this.handleHelperText(
                      this.state.latitude,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.latitude)
                        : false,
                      value: this.state.latitude,
                      onChange: e => this.handleChangeText("latitude", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={10} sm={10} md={10}>
                  <CustomInput
                    labelText="Longitude"
                    id="longitude"
                    helpText={this.handleHelperText(
                      this.state.longitude,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.longitude)
                        : false,
                      value: this.state.longitude,
                      onChange: e => this.handleChangeText("longitude", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
              </GridContainer>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.handleClose("openAdd", false)}
                color="danger"
                round
              >
                Cancel
              </Button>
              {this.renderAction()}
            </DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>
    );
  }
}
function mapStateToProps(state) {
  return {};
}

export default withRouter(
  connect(
    mapStateToProps,
    { pushLoader }
  )(Office)
);
